import _slicedToArray from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/regenerator/index.js";
import { executeOnSingleOrMultiple, safeMatchMedia } from "../../Utils/Utils";
import { mouseDownEvent, mouseLeaveEvent, mouseMoveEvent, mouseOutEvent, mouseUpEvent, resizeEvent, touchCancelEvent, touchEndEvent, touchMoveEvent, touchStartEvent, visibilityChangeEvent } from "./Constants";
function manageListener(element, event, handler, add, options) {
  if (add) {
    var addOptions = {
      passive: true
    };
    if (typeof options === "boolean") {
      addOptions.capture = options;
    } else if (options !== undefined) {
      addOptions = options;
    }
    element.addEventListener(event, handler, addOptions);
  } else {
    var removeOptions = options;
    element.removeEventListener(event, handler, removeOptions);
  }
}
export var EventListeners = /*#__PURE__*/function () {
  function EventListeners(container) {
    var _this = this;
    _classCallCheck(this, EventListeners);
    this.container = container;
    this.canPush = true;
    this.mouseMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchStartHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchEndHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.mouseLeaveHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.touchCancelHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.touchEndClickHandler = function (e) {
      return _this.mouseTouchClick(e);
    };
    this.mouseUpHandler = function (e) {
      return _this.mouseTouchClick(e);
    };
    this.mouseDownHandler = function () {
      return _this.mouseDown();
    };
    this.visibilityChangeHandler = function () {
      return _this.handleVisibilityChange();
    };
    this.themeChangeHandler = function (e) {
      return _this.handleThemeChange(e);
    };
    this.oldThemeChangeHandler = function (e) {
      return _this.handleThemeChange(e);
    };
    this.resizeHandler = function () {
      return _this.handleWindowResize();
    };
  }
  _createClass(EventListeners, [{
    key: "addListeners",
    value: function addListeners() {
      this.manageListeners(true);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.manageListeners(false);
    }
  }, {
    key: "doMouseTouchClick",
    value: function doMouseTouchClick(e) {
      var _this2 = this;
      var container = this.container,
        options = container.actualOptions;
      if (this.canPush) {
        var mousePos = container.interactivity.mouse.position;
        if (!mousePos) {
          return;
        }
        container.interactivity.mouse.clickPosition = Object.assign({}, mousePos);
        container.interactivity.mouse.clickTime = new Date().getTime();
        var onClick = options.interactivity.events.onClick;
        executeOnSingleOrMultiple(onClick.mode, function (mode) {
          return _this2.handleClickMode(mode);
        });
      }
      if (e.type === "touchend") {
        setTimeout(function () {
          return _this2.mouseTouchFinish();
        }, 500);
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this.container.handleClickMode(mode);
    }
  }, {
    key: "handleThemeChange",
    value: function handleThemeChange(e) {
      var mediaEvent = e,
        themeName = mediaEvent.matches ? this.container.options.defaultDarkTheme : this.container.options.defaultLightTheme,
        theme = this.container.options.themes.find(function (theme) {
          return theme.name === themeName;
        });
      if (theme && theme.default.auto) {
        this.container.loadTheme(themeName);
      }
    }
  }, {
    key: "handleVisibilityChange",
    value: function handleVisibilityChange() {
      var container = this.container,
        options = container.actualOptions;
      this.mouseTouchFinish();
      if (!options.pauseOnBlur) {
        return;
      }
      if (document === null || document === void 0 ? void 0 : document.hidden) {
        container.pageHidden = true;
        container.pause();
      } else {
        container.pageHidden = false;
        if (container.getAnimationStatus()) {
          container.play(true);
        } else {
          container.draw(true);
        }
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this3 = this;
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        delete this.resizeTimeout;
      }
      this.resizeTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_a = _this3.container.canvas) === null || _a === void 0 ? void 0 : _a.windowResize());
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 500);
    }
  }, {
    key: "manageListeners",
    value: function manageListeners(add) {
      var _this4 = this;
      var _a;
      var container = this.container,
        options = container.actualOptions,
        detectType = options.interactivity.detectsOn;
      var mouseLeaveTmpEvent = mouseLeaveEvent;
      if (detectType === "window") {
        container.interactivity.element = window;
        mouseLeaveTmpEvent = mouseOutEvent;
      } else if (detectType === "parent" && container.canvas.element) {
        var canvasEl = container.canvas.element;
        container.interactivity.element = (_a = canvasEl.parentElement) !== null && _a !== void 0 ? _a : canvasEl.parentNode;
      } else {
        container.interactivity.element = container.canvas.element;
      }
      var mediaMatch = safeMatchMedia("(prefers-color-scheme: dark)");
      if (mediaMatch) {
        if (mediaMatch.addEventListener !== undefined) {
          manageListener(mediaMatch, "change", this.themeChangeHandler, add);
        } else if (mediaMatch.addListener !== undefined) {
          if (add) {
            mediaMatch.addListener(this.oldThemeChangeHandler);
          } else {
            mediaMatch.removeListener(this.oldThemeChangeHandler);
          }
        }
      }
      var interactivityEl = container.interactivity.element;
      if (!interactivityEl) {
        return;
      }
      var html = interactivityEl;
      if (options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable) {
        manageListener(interactivityEl, mouseMoveEvent, this.mouseMoveHandler, add);
        manageListener(interactivityEl, touchStartEvent, this.touchStartHandler, add);
        manageListener(interactivityEl, touchMoveEvent, this.touchMoveHandler, add);
        if (!options.interactivity.events.onClick.enable) {
          manageListener(interactivityEl, touchEndEvent, this.touchEndHandler, add);
        } else {
          manageListener(interactivityEl, touchEndEvent, this.touchEndClickHandler, add);
          manageListener(interactivityEl, mouseUpEvent, this.mouseUpHandler, add);
          manageListener(interactivityEl, mouseDownEvent, this.mouseDownHandler, add);
        }
        manageListener(interactivityEl, mouseLeaveTmpEvent, this.mouseLeaveHandler, add);
        manageListener(interactivityEl, touchCancelEvent, this.touchCancelHandler, add);
      }
      if (container.canvas.element) {
        container.canvas.element.style.pointerEvents = html === container.canvas.element ? "initial" : "none";
      }
      if (options.interactivity.events.resize) {
        if (typeof ResizeObserver !== "undefined") {
          if (this.resizeObserver && !add) {
            if (container.canvas.element) {
              this.resizeObserver.unobserve(container.canvas.element);
            }
            this.resizeObserver.disconnect();
            delete this.resizeObserver;
          } else if (!this.resizeObserver && add && container.canvas.element) {
            this.resizeObserver = new ResizeObserver(function (entries) {
              var entry = entries.find(function (e) {
                return e.target === container.canvas.element;
              });
              if (!entry) {
                return;
              }
              _this4.handleWindowResize();
            });
            this.resizeObserver.observe(container.canvas.element);
          }
        } else {
          manageListener(window, resizeEvent, this.resizeHandler, add);
        }
      }
      if (document) {
        manageListener(document, visibilityChangeEvent, this.visibilityChangeHandler, add, false);
      }
    }
  }, {
    key: "mouseDown",
    value: function mouseDown() {
      var interactivity = this.container.interactivity;
      if (interactivity) {
        var mouse = interactivity.mouse;
        mouse.clicking = true;
        mouse.downPosition = mouse.position;
      }
    }
  }, {
    key: "mouseTouchClick",
    value: function mouseTouchClick(e) {
      var container = this.container,
        options = container.actualOptions,
        mouse = container.interactivity.mouse;
      mouse.inside = true;
      var handled = false;
      var mousePosition = mouse.position;
      if (!mousePosition || !options.interactivity.events.onClick.enable) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(container.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            plugin = _step$value[1];
          if (!plugin.clickPositionValid) {
            continue;
          }
          handled = plugin.clickPositionValid(mousePosition);
          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!handled) {
        this.doMouseTouchClick(e);
      }
      mouse.clicking = false;
    }
  }, {
    key: "mouseTouchFinish",
    value: function mouseTouchFinish() {
      var interactivity = this.container.interactivity;
      if (!interactivity) {
        return;
      }
      var mouse = interactivity.mouse;
      delete mouse.position;
      delete mouse.clickPosition;
      delete mouse.downPosition;
      interactivity.status = mouseLeaveEvent;
      mouse.inside = false;
      mouse.clicking = false;
    }
  }, {
    key: "mouseTouchMove",
    value: function mouseTouchMove(e) {
      var _a, _b, _c, _d, _e, _f, _g;
      var container = this.container,
        options = container.actualOptions;
      if (!((_a = container.interactivity) === null || _a === void 0 ? void 0 : _a.element)) {
        return;
      }
      container.interactivity.mouse.inside = true;
      var pos;
      var canvas = container.canvas.element;
      if (e.type.startsWith("pointer")) {
        this.canPush = true;
        var mouseEvent = e;
        if (container.interactivity.element === window) {
          if (canvas) {
            var clientRect = canvas.getBoundingClientRect();
            pos = {
              x: mouseEvent.clientX - clientRect.left,
              y: mouseEvent.clientY - clientRect.top
            };
          }
        } else if (options.interactivity.detectsOn === "parent") {
          var source = mouseEvent.target,
            target = mouseEvent.currentTarget,
            canvasEl = container.canvas.element;
          if (source && target && canvasEl) {
            var sourceRect = source.getBoundingClientRect(),
              targetRect = target.getBoundingClientRect(),
              canvasRect = canvasEl.getBoundingClientRect();
            pos = {
              x: mouseEvent.offsetX + 2 * sourceRect.left - (targetRect.left + canvasRect.left),
              y: mouseEvent.offsetY + 2 * sourceRect.top - (targetRect.top + canvasRect.top)
            };
          } else {
            pos = {
              x: (_b = mouseEvent.offsetX) !== null && _b !== void 0 ? _b : mouseEvent.clientX,
              y: (_c = mouseEvent.offsetY) !== null && _c !== void 0 ? _c : mouseEvent.clientY
            };
          }
        } else if (mouseEvent.target === container.canvas.element) {
          pos = {
            x: (_d = mouseEvent.offsetX) !== null && _d !== void 0 ? _d : mouseEvent.clientX,
            y: (_e = mouseEvent.offsetY) !== null && _e !== void 0 ? _e : mouseEvent.clientY
          };
        }
      } else {
        this.canPush = e.type !== "touchmove";
        var touchEvent = e,
          lastTouch = touchEvent.touches[touchEvent.touches.length - 1],
          _canvasRect = canvas === null || canvas === void 0 ? void 0 : canvas.getBoundingClientRect();
        pos = {
          x: lastTouch.clientX - ((_f = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.left) !== null && _f !== void 0 ? _f : 0),
          y: lastTouch.clientY - ((_g = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.top) !== null && _g !== void 0 ? _g : 0)
        };
      }
      var pxRatio = container.retina.pixelRatio;
      if (pos) {
        pos.x *= pxRatio;
        pos.y *= pxRatio;
      }
      container.interactivity.mouse.position = pos;
      container.interactivity.status = mouseMoveEvent;
    }
  }]);
  return EventListeners;
}();